function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_7149",
  "data-name": "Group 7149",
  transform: "translate(-93.41 -379.5)"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun_Worker_3856238",
  transform: "translate(93.41 379.5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3409",
  "data-name": "Path 3409",
  d: "M68.458,63.877C55.95,63.877,45.775,53.166,45.775,40H41c0,15.8,12.317,28.652,27.458,28.652S95.917,55.8,95.917,40H91.142C91.142,53.166,80.966,63.877,68.458,63.877Z",
  transform: "translate(-9.96 7.758)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3410",
  "data-name": "Path 3410",
  d: "M39.388,42.979H99.08a2.388,2.388,0,0,0,2.388-2.388V33.715a2.391,2.391,0,0,0-.758-1.745L98.8,30.19a27.284,27.284,0,0,0-15.735-24V5.069A5.319,5.319,0,0,0,77.541,0H60.928A5.323,5.323,0,0,0,55.4,5.073V6.205A27.3,27.3,0,0,0,39.665,30.188L37.758,31.97A2.391,2.391,0,0,0,37,33.715v6.876a2.388,2.388,0,0,0,2.388,2.388ZM69.234,19.1a2.388,2.388,0,1,1-2.388,2.388A2.388,2.388,0,0,1,69.234,19.1ZM41.775,34.752l1.9-1.774a2.389,2.389,0,0,0,.753-1.891A22.487,22.487,0,0,1,58.7,9.963a2.389,2.389,0,0,0,1.473-2.206l0-2.665a.881.881,0,0,1,.758-.316h5.918v9.968a7.163,7.163,0,1,0,4.775,0V4.776h5.919a.926.926,0,0,1,.753.293V7.747a2.388,2.388,0,0,0,1.473,2.206A22.25,22.25,0,0,1,94.039,31.085a2.388,2.388,0,0,0,.753,1.892l1.9,1.774V38.2H41.775Z",
  transform: "translate(-10.735 0.004)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3411",
  "data-name": "Path 3411",
  d: "M22.163,135.631a2.39,2.39,0,0,1-2.388-2.388V87.4c0-2.791,2.9-6.211,5.531-7.455l20.734-7.5V85.489h4.775s.027-14.622,0-14.765l4.043-1.479L66.6,85.489h5.89L57.675,64.99a2.392,2.392,0,0,0-2.748-.848L23.583,75.486q-.092.033-.18.073C19.272,77.448,15,82.391,15,87.4v45.848a7.171,7.171,0,0,0,7.163,7.163H35.949a14.259,14.259,0,0,1-2.871-4.775Z",
  transform: "translate(-15 12.411)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3412",
  "data-name": "Path 3412",
  d: "M113.932,75.559q-.088-.04-.18-.073L82.407,64.142a2.393,2.393,0,0,0-2.748.848l-14.812,20.5h5.89L82.476,69.245l4.087,1.479c-.027.142-.044,14.765-.044,14.765h4.775V72.437l20.734,7.5c2.628,1.244,5.531,4.664,5.531,7.455v45.848a2.391,2.391,0,0,1-2.388,2.388H104.256a14.259,14.259,0,0,1-2.871,4.775h13.786a7.171,7.171,0,0,0,7.163-7.163V87.4C122.334,82.391,118.062,77.448,113.932,75.559Z",
  transform: "translate(-5.337 12.411)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3413",
  "data-name": "Path 3413",
  d: "M112.38,88.546A7.243,7.243,0,0,0,106.74,86H35.226a7.023,7.023,0,0,0-7.073,8.587l6.538,33.871a9.73,9.73,0,0,0,9.293,7.684h54a9.73,9.73,0,0,0,9.293-7.684l6.538-33.871a7.267,7.267,0,0,0-1.433-6.042Zm-3.256,5.137-6.538,33.871a4.955,4.955,0,0,1-4.6,3.813h-54a4.955,4.955,0,0,1-4.6-3.813s-6.518-33.772-6.538-33.871a2.332,2.332,0,0,1,2.384-2.907H106.74a2.318,2.318,0,0,1,2.384,2.907Z",
  transform: "translate(-12.485 16.675)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_262",
  "data-name": "Ellipse 262",
  cx: 2.388,
  cy: 2.388,
  r: 2.388,
  transform: "translate(56.111 125.358)"
})), /*#__PURE__*/React.createElement("g", {
  id: "noun_forms_1236251",
  transform: "translate(206.068 451.508)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3398",
  "data-name": "Path 3398",
  d: "M72.281,25.242a1.642,1.642,0,0,0-.468-1.149L52.982,4.893A1.642,1.642,0,0,0,51.808,4.4H23.489a8.209,8.209,0,0,0-8.209,8.209v58.47a8.209,8.209,0,0,0,8.209,8.209H64.072a8.209,8.209,0,0,0,8.209-8.209ZM53.319,9.908l14.193,14.48H55.781a2.463,2.463,0,0,1-2.463-2.463ZM64.072,76H23.489a4.925,4.925,0,0,1-4.925-4.925V12.584a4.925,4.925,0,0,1,4.925-4.925H50.035V21.925a5.746,5.746,0,0,0,5.746,5.746H69V71.079A4.925,4.925,0,0,1,64.072,76Z",
  transform: "translate(0 0)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3399",
  "data-name": "Path 3399",
  d: "M64.314,48.26H42.192a1.642,1.642,0,1,0,0,3.283H64.314a1.642,1.642,0,1,0,0-3.283Z",
  transform: "translate(-4.527 -7.857)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3400",
  "data-name": "Path 3400",
  d: "M29.963,47.26a2.463,2.463,0,1,0,0,4.925H30a2.463,2.463,0,1,0-.041-4.925Z",
  transform: "translate(-2.189 -7.678)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3401",
  "data-name": "Path 3401",
  d: "M64.314,61.26H42.192a1.642,1.642,0,1,0,0,3.283H64.314a1.642,1.642,0,1,0,0-3.283Z",
  transform: "translate(-4.527 -10.186)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3402",
  "data-name": "Path 3402",
  d: "M29.963,60.26a2.463,2.463,0,1,0,0,4.925H30a2.463,2.463,0,1,0-.041-4.925Z",
  transform: "translate(-2.189 -10.006)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3403",
  "data-name": "Path 3403",
  d: "M64.314,74.26H42.192a1.642,1.642,0,1,0,0,3.283H64.314a1.642,1.642,0,1,0,0-3.283Z",
  transform: "translate(-4.527 -12.514)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3404",
  "data-name": "Path 3404",
  d: "M29.963,73.26a2.463,2.463,0,0,0,0,4.925H30a2.463,2.463,0,1,0-.041-4.925Z",
  transform: "translate(-2.189 -12.335)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_7148",
  "data-name": "Group 7148",
  transform: "translate(-33 5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3840",
  "data-name": "Path 3840",
  d: "M10319.037,714.788s4.239,8.875,12.343,8.543,10.972-5.9,12.422-8.543",
  transform: "translate(-10053 -282)",
  fill: "none",
  stroke: "#f26700",
  strokeLinecap: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3841",
  "data-name": "Path 3841",
  d: "M10318.3,709.5h26.855s-.552-11.21-10.687-13.774-15.506,7.352-15.527,8.409",
  transform: "translate(-10053 -282)",
  fill: "none",
  stroke: "#f26700",
  strokeLinecap: "round",
  strokeWidth: 3
})));

function SvgStepper2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 184.939,
    height: 152.817,
    viewBox: "0 0 184.939 152.817",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepper2);
export default __webpack_public_path__ + "static/media/stepper2.f6a794a587f42426574f2c0051a9b0d7.svg";
export { ForwardRef as ReactComponent };